export function DotPattern() {
  return (
    <div
      className="fixed inset-0 pointer-events-none -z-10"
      style={{
        backgroundImage: 'radial-gradient(circle, var(--muted) 0.5px, transparent 0.5px)',
        backgroundSize: '24px 24px',
        opacity: 'var(--dot-opacity)',
      }}
    />
  )
}
